// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"178":"item","596":"404","680":"monster"}[chunkId] || chunkId) + "." + {"178":"898df4a8","591":"f2463652","596":"e38a4898","680":"5570a9f9"}[chunkId] + ".js";
};